@if (!isCheckingPermission && isUnauthorized) { 
  <div class="pt-38 unauth-container pb-50">
    <img class="image" src="/assets/images/unauthorized.svg">
    <div class="fw-600 fs-20 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
  </div>
} @else if (!isCheckingPermission && !isUnauthorized) {
<div class="deploy-sizing mb-24 deploy-page" [ngClass]="{'mt-24 mb--24': isDialogMode}">
    <div *ngIf="!isDialogMode" class="pt-12 ml-34 mr-12">
        <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>
    <div class="pl-24 pt-16 pb-12 mt--14 header-section">
        <div class="flex flex-row flex-auto">
            <div *ngIf="!isDialogMode" class="flex flex-row items-start mt-4">
                <mat-icon (click)="goBack()" class="icon cursor-pointer" svgIcon="arrow_back"></mat-icon>
            </div>
            <div class="flex flex-col ml-12">
                <div class="mat-subtitle-1 fw-600 mb-0">{{ isEditMode ? ('UPDATE_MANAGER.EDIT_DOCUMENT' | transloco) : ('INFRA.CREATE_NEW' | transloco) }}</div>
                <div class="flex flex-row mt-12 header-meta">
                    <div class="mr-12">{{'BLUEPRINT_SUMMARY.SUMMARY.SERVICE_DEFINITION' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{ blueprint?.name}}</span>
                    </div>
                    <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
                    <div class="pl-12 mr-12">{{'BLUEPRINT_SUMMARY.SUMMARY.ENVIRONMENT' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{ instance?.name }}</span>
                    </div>
                    <span class="vertical-divider" [class.loading-divider]="isLoading"></span>
                    <div class="pl-12">{{'SIZING.SIZING' | transloco}}
                        <span *ngIf="!isLoading; else loader">{{'SIZING.SIZE' | transloco}}</span>
                    </div>
                </div>
                <ng-template #loader>
                    <span class="skeleton-loader">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '22px', width: '120px' }"></ngx-skeleton-loader>
                    </span>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isEditMode && (!isGlobalLoading || hasNoSizingData)" class="sizing-doc-banner">
    <span class="label">Name: {{ sizingDocumentName || '-' }}</span>
    <span class="separator">|</span>
    <span class="label">Created: {{ sizingCreatedDate ? (sizingCreatedDate | date: 'MMM dd, yyyy') : '-'}}</span>
    <span class="separator">|</span>
    <mat-icon class="account-circle" svgIcon="account_circle_filled" matTooltipClass="tooltip-inner right" [matTooltip]="sizingCreatedBy" [matTooltipPosition]="'right'"></mat-icon>
</div>
<div class="sizing-root" [class.dialog-sizing-root]="isDialogMode">
    <div class="sizing-toolbar">
        <div class="left">
            <div class="tabs">
                <span class="tab" [class.active]="currentView === SizingViewMode.FORM" (click)="switchView(SizingViewMode.FORM)">{{'CUSTOM_IMAGES.FORM' | transloco}}</span>
                <span class="vertical-divider"></span>
                <span class="tab" [class.active]="currentView === SizingViewMode.JSON" (click)="switchView(SizingViewMode.JSON)">{{'CUSTOM_IMAGES.JSON' | transloco}}</span>
            </div>
            <div class="search-box">
                <input class="fs-14 fw-500" type="text" placeholder="Search" [(ngModel)]="searchTerm" (input)="applySearch()" />
                <mat-icon class="icon-search" svgIcon="search"></mat-icon>
            </div>
            @if (templateResponse) {
                <button class="download-btn" (click)="downloadJson()">
                    <mat-icon svgIcon="file_download"></mat-icon>
                    {{'CUSTOM_IMAGES.DOWNLOAD_JSON' | transloco}}
                </button>
            }
        </div>
    </div>
    <div *ngIf="currentView === SizingViewMode.FORM">
        <div class="sizing-body">
            @if (hasNoSizingData && !searchTerm?.trim()) {
                <div class="no-results">
                    <img src="assets/images/no-template.png" alt="No Results" />
                    <div class="no-results-text">{{'SIZING.NO_RECORD' | transloco }}</div>
                </div>
            }  @else {
                @if (sizingCards?.length === 0 && searchTerm?.trim()) {
                    <div class="no-results">
                        <img src="assets/images/no_result.svg" alt="No Results" />
                        <div class="no-results-text">{{'COMMON_MESSAGE.NO_RESULTS_FOUND' | transloco }}</div>
                    </div>
                } @else {
            <div *ngFor="let card of filteredSizingCards" class="sizing-card" [class.edited-card]="card.edited">
                <div class="card-header floating">
                    <div class="header-left">
                        <span class="fs-10 fw-700 pill pill-transact">{{ card.title }}</span>
                        <span class="fs-10 fw-700 pill pill-database">{{ card.component }}</span>
                        <span *ngIf="card?.edited" class="edited-tag fs-10 fw-700">{{'INFRA.EDITED' | transloco }}</span>
                    </div>
                    <button *ngIf="!isDialogMode" class="menu-button fw-500 fs-16" (click)="editSizing(card)">
                        <mat-icon svgIcon="edit" class="icon-sm"></mat-icon>
                        <span>{{'SOLUTIONS.EDIT' | transloco }}</span>
                    </button>
                </div>
                <div *ngFor="let section of card.sections; let last = last" class="section">
                    <div class="section-title fs-14 fw-700">
                        {{ section.sectionTitle }}
                    </div>
                    <div class="metrics-row">
                        <div *ngFor="let metric of section.metrics" class="metric">
                            {{ metric.label }}: {{ metric.value }}
                        </div>
                    </div>
                    <div *ngIf="!last" class="divider-line"></div>
                </div>
            </div>
        }
       @if(!validSchema && errorsWithComponent && !searchTerm) {
            <div class="no-results">
                <div class="flex flex-col items-center">
                    <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                    <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE1' | transloco }}</div>
                    <div class="mat-subtitle-2 fs-16 fw-600 mt-16">{{'SIZING.VALIDATE_MESSAGE2' | transloco }}</div>
                    <span class="agent-link mat-body-2 mt-24" (click)="showErrorDialog(false)">{{'SIZING.VIEW_DETAILS'| transloco}}</span>
                </div>
            </div>
        }
    
        @if(retrySizing) {
            <div class="no-results">
                    <div class="flex flex-col items-center">
                        <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
                        <div class="mat-subtitle-2 fs-16 fw-600 mt-16 mr-8">{{'SIZING.SIZING_VALIDATION' | transloco }}</div>
                        <div class="flex flex-row justify-center items-center mt-24">
                            <button class="white mr-20 report-letter-spacing" type="button" (click)="startSizingProcess()"> {{ 'ERROR_DIALOG.RETRY' | transloco }} </button>
                            <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
                        </div>
                    </div>
                </div>
            }
    }
        </div>
    </div>
    <div *ngIf="currentView === SizingViewMode.JSON" class="json-view">
        <div class="editor-container">
            <div><ngx-monaco-editor *ngIf="!isJsonLoading" [options]="editorOptions" [model]="jsonInput" class="editor"></ngx-monaco-editor></div>
        </div>
        <div *ngIf="isJsonLoading " class="editor-loader">
            <mat-spinner diameter="18"></mat-spinner>
        </div>
    </div>
    <div *ngIf="!isGlobalLoading || retrySizing" class="deploy-footer">
        <div class="footer-divider"></div>
        <div class="footer-actions">
            <button class="flex justify-items-center items-center cancel-btn pr-16 pl-16 pt-8 pb-8" (click)="goBack()">{{ 'BUTTONS.CANCEL' | transloco }}</button>
            <button  [disabled]="isLoading || isSubmitting || isSubmitClicked || retrySizing || (isEditMode && !hasChanges())" class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" (click)="validSchema ? onSizingAction() :''" [ngClass]="{'disabled': !validSchema || isSubmitting || (isEditMode && !hasChanges())}">
                {{'BUTTONS.SUBMIT' | transloco }}
            </button>
        </div>
    </div>
</div>
} 